module.exports = __webpack_public_path__ + "img/icon-circle-line-white.92c37586.svg";